import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../../components/Sidebar";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from '../../config/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faTrash,
  faMoneyBillWave,
  faMoneyBill
} from "@fortawesome/free-solid-svg-icons";
import { useMemo } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Button, Modal } from "react-bootstrap";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";

const CourseList = () => {
    let navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [coursesdata, setcoursesdata] = useState([]);
  const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const paginationPageSizeSelector = useMemo(() => {
      return [10, 20, 50, 100];
    }, []);

    const [selectedid, setselectedid] = useState(0);
    const [pricetable, setpricetable] = useState([]);
    const [showpricetable, setshowpricetable] = useState(false);
    const [forceupdate, setforceupdate] = useState(false);

    const pricetableRef = useRef(null);
    pricetableRef.current = pricetable;

    const selectedidRef = useRef(null);
    selectedidRef.current = selectedid;

    const fetchcountrieslist = async() => {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };

      let resp = await axios
        .get(apiUrl + "getallcountries", headers)
        .then((res) => {
          if (res.data.status == "success") {
            console.log('getallcountries >>', res.data);
            var prevdata = res.data.data;
            console.log('prevdata >>', prevdata);
            var priceobjarr = {};
            for(var i = 0; i < prevdata?.length; i++) {
              priceobjarr[prevdata[i]?.shortcode] = {}
              priceobjarr[prevdata[i]?.shortcode]['country'] = prevdata[i]?.country;
              priceobjarr[prevdata[i]?.shortcode]['currency'] = prevdata[i]?.currency;
              priceobjarr[prevdata[i]?.shortcode]['personprice'] = "";
              priceobjarr[prevdata[i]?.shortcode]['personofferprice'] = "";
              priceobjarr[prevdata[i]?.shortcode]['liveonlineprice'] = "";
              priceobjarr[prevdata[i]?.shortcode]['liveonlineofferprice'] = "";
              priceobjarr[prevdata[i]?.shortcode]['onlineselfprice'] = "";
              priceobjarr[prevdata[i]?.shortcode]['onlineselfofferprice'] = "";
            }

            console.log('priceobjarr >>', priceobjarr);
            setpricetable(priceobjarr)
            
            console.log('Object keys >>', Object.keys(priceobjarr));
          } else {
            // alert(res.data.message);
          }
        })
        .catch((err) => {
          alert(err.message);
        });
    }


    const handlechangestatus = async(id, status) => {
      console.log('id >>', id);
      console.log('sttaus >>', status);
      var data = JSON.stringify({
        id: id,
        status: status ? 'true' : 'false'
      });
      const headers = {
        headers: {
          "Content-Type": "application/json",
          'Authorization' : 'Bearer ' + userdata?.token
        },
      };
      let resp = await axios
        .post(apiUrl + "coursechangestatusv2",data, headers)
        .then((res) => {
          if (res.data.status == "success") {
            fetchallcourses();
          } else {
          }
        })
        .catch((err) => {
          alert(err.message);
        });
    }

    const handlepricetablemodel = (data) => {
      console.log('data >>', data);
      setselectedid(data?.id);
      if(data?.pricetable) {
        var olddata = JSON.parse(data?.pricetable);
        var prevdata = pricetableRef.current;
        console.log('prevdata >>', Object.keys(prevdata));
        var prevkeys = Object.keys(prevdata);
        var newtableobjarr = {};
        for(var i = 0; i < prevkeys?.length; i++) {
          var key = prevkeys[i];
          console.log('prevdata >>', prevdata[prevkeys[i]]);
          newtableobjarr[key] = {};
          newtableobjarr[key]['country'] = prevdata[prevkeys[i]]['country'];
          newtableobjarr[key]['currency'] = prevdata[prevkeys[i]]['currency'];
          newtableobjarr[key]['personprice'] = olddata[key]?.personprice ? olddata[key]?.personprice : 0;
          newtableobjarr[key]['personofferprice'] = olddata[key]?.personofferprice ? olddata[key]?.personofferprice : 0;
          newtableobjarr[key]['liveonlineprice'] = olddata[key]?.liveonlineprice ? olddata[key]?.liveonlineprice : 0;
          newtableobjarr[key]['liveonlineofferprice'] = olddata[key]?.liveonlineofferprice ? olddata[key]?.liveonlineofferprice : 0;
          newtableobjarr[key]['onlineselfprice'] = olddata[key]?.onlineselfprice ? olddata[key]?.onlineselfprice : 0;
          newtableobjarr[key]['onlineselfofferprice'] = olddata[key]?.onlineselfofferprice ? olddata[key]?.onlineselfofferprice : 0;
        }
        console.log('olddata >>', olddata);
        console.log('newtableobjarr >>', newtableobjarr);
        setpricetable(newtableobjarr);
        setforceupdate(!forceupdate);
      } else {

      }
      setshowpricetable(true);
    }

  const fetchallcourses = async() => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        'Authorization' : 'Bearer ' + userdata?.token
      },
    };
    let resp = await axios
      .get(apiUrl + "getallcourses", headers)
      .then((res) => {
        if (res.data.status == "success") {
          // console.log('getallcategories >>', res.data);
          var prevdata = res.data.data;
          // setcoursesdata(res.data.data);
          if(prevdata?.length > 0) {
            var columnsarr = [];
            var hidecolumns = ['id', 'updated_at','created_at', 'sort', 'status', 'pricetable'];
            var hidefilters = [];
            var columns = Object.keys(prevdata[0]);
            for(var i = 0; i < columns?.length;i++) {
              if(!hidecolumns.includes(columns[i])) {
                var obj = {};
                obj.field = columns[i];
                if(!hidefilters.includes(columns[i])) {
                  obj.filter = true;
                  obj.filterParams = {
                      filterOptions: ["contains"],
                      maxNumConditions: 1,
                  };
                }
              //   console.log('obj >>', obj)
                columnsarr.push(obj);
              }
            }
             //active
             var activeobj = 
             {
               field: "status",
               headerName: "Status",
               cellRenderer: (props) => {
                 
                 return (
                   <div
                     onClick={() => {
                       // editlocation(props?.data?.id);
                      //  navigate("/webadmin/editcourse/" + props?.data?.id);
                       // console.log('props >>', props?.data);
                     }}
                     style={{
                       maxWidth: 35,
                       paddingLeft: 10,
                       paddingRight: 10,
                       cursor: "pointer",
                     }}
                   >
                    <div className="coursecheckbox">
                      <input class="form-check-input" onChange={(t) => {
                        handlechangestatus(props?.data?.id, t.target.checked)
                      }} type="checkbox" checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}  />
                    </div>
                     
                   </div>
                 );
               },
               cellRendererParams: {
                 onClick: clickhandle,
               },
             }
             columnsarr.push(activeobj);

             //Amount
            var editobj = 
            {
              field: "price",
              headerName: "Price",
              cellRenderer: (props) => {
                
                return (
                  <div
                        onClick={() => {
                          // editlocation(props?.data?.id);
                          // navigate('/webadmin/editcourse/'+props?.data?.id)
                          // console.log('props >>', props?.data);
                          handlepricetablemodel(props?.data);
                        }}
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faMoneyBill}
                          className="sidebaricons"
                          style={{ color: "blue", width: 20, height: 20 }}
                        />
                      </div>
                )
              },
              cellRendererParams: {
                onClick: clickhandle,
              },
            }
            columnsarr.push(editobj);


            //edit
            var editobj = 
            {
              field: "edit",
              headerName: "Edit",
              cellRenderer: (props) => {
                
                return (
                  <div
                        onClick={() => {
                          // editlocation(props?.data?.id);
                          navigate('/webadmin/editcourse/'+props?.data?.id)
                          // console.log('props >>', props?.data);
                        }}
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="sidebaricons"
                          style={{ color: "blue" }}
                        />
                      </div>
                )
              },
              cellRendererParams: {
                onClick: clickhandle,
              },
            }
            columnsarr.push(editobj);
            //delete
            var deleteobj = 
            {
              field: "delete",
              headerName: "Delete",
              cellRenderer: (props) => {
                
                return (
                  <div
                        onClick={() => {
                          deletecourse(props?.data?.id, props?.data?.code);
                          // console.log('props >>', props?.data);
                        }}
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="sidebaricons"
                          style={{ color: "red" }}
                        />
                      </div>
                )
              },
              cellRendererParams: {
                onClick: clickhandle,
              },
            }
            columnsarr.push(deleteobj);
            setColDefs(columnsarr);
            setRowData(prevdata);
          }
        } else {
          // alert(res.data.message);
        }
      })
      .catch((err) => {
        alert(err.message);
      });
  }
  const clickhandle = () =>  {
    console.log('Mission Launched')
  }
  const defaultColDef = {
    flex: 1,
  };
  const deletecourse = async(id, title) => {
    const result = window.confirm('Are you sure you want '+title);
    if (result) {
      var data = JSON.stringify({
      id: id
    });
    const headers = {
      headers: {
        "Content-Type": "application/json",
        'Authorization' : 'Bearer ' + userdata?.token
      },
    };
    let resp = await axios
      .post(apiUrl + "deletecourse",data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          fetchallcourses();
        } else {
        }
      })
      .catch((err) => {
        alert(err.message);
      });
    } else {
      // User clicked Cancel or closed the dialog
      console.log('User clicked Cancel');
    }
    
  }

  const handleclosemodal = () => {
    setshowpricetable(false);
    window.location.reload();
  }

  const handlepricechange = (shortcode,key, value ) => {
    var prevdata = pricetableRef.current;
    prevdata[shortcode][key] = value;
    setpricetable(prevdata);
    setforceupdate(!forceupdate);
  }

  const submithandle = async() => {
    var data = JSON.stringify({
      id: selectedidRef?.current,
      pricetable: pricetableRef.current
    });
    const headers = {
      headers: {
          'Content-Type': 'application/json',
          'Authorization' : 'Bearer ' + userdata?.token
      }
    }
    let resp = await axios.post(apiUrl + 'editcoursepricetable', data, headers).then((res) => {
      console.log('res >>', res)
      if(res.data.status == 'success') {
        // navigate('/webadmin/courselist');
        setselectedid(0);
        setshowpricetable(false);
        window.location.reload();
      } else {
        alert(res.data.message);
      }
  } ).catch((err) => {
      alert(err.message)
  })

    console.log('sibmit >>', data);
  }

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
        //   fetchdata();
          fetchallcourses();
          fetchcountrieslist();
        } else {
          navigate("/newadminlogin");
        }
      }, []);
      return (
        <div className="HomeMain">
          <div className="sidebar-div">
            <Sidebar name={"Admin"} />
          </div>
          <div className="main-layout">
            <div className="mainDiv">
              <p className="oneplaceHead">COURSES LIST</p>
              <br />
              <br />
              {/* <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style={{minWidth: 100}}>Sr No.</th>
                    <th>Course Name</th>
                    <th>Course Slug</th>
                    <th>Course Category</th>
                    <th>Status</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    coursesdata?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.slug}</td>
                          <td>{item.category}</td>
                          <td><input type="checkbox" class="myCheckbox" data-id={item.id} style={{margin: 15}}   /></td>
                          <td>
                            <Link to={'/webadmin/editcourse/'+item.id}>
                              <FontAwesomeIcon icon={faPenToSquare} className="sidebaricons" />
                            </Link>
                          </td>
                          <td>
                            <div onClick={() => {deletecourse(item.id, item.title)}}>
                              <FontAwesomeIcon icon={faTrash} className="sidebaricons" style={{color: 'red'}} />
                            </div>
                            
                            </td>
                        </tr>
                      );
                    })
                  }

                </tbody>
              </table> */}
              <div
                className={"ag-theme-quartz"}
                style={{ width: "100%", height: 550 }}
              >
                <AgGridReact
                  // modules={AllModules}
                  rowData={rowData}
                  columnDefs={colDefs}
                  defaultColDef={defaultColDef}
                  suppressRowClickSelection={true}
                  groupSelectsChildren={true}
                  rowSelection={"multiple"}
                  pagination={true}
                  paginationPageSize={10}
                  paginationPageSizeSelector={paginationPageSizeSelector}
                  // onGridReady={onGridReady}
                />
              </div>

              {/*Add modal */}
              <Modal
                show={showpricetable}
                onHide={() => {handleclosemodal()}}
                size="xl"
                className="custom-width-modal"
              >
                <Modal.Header closeButton>
                  <Modal.Title style={{ fontSize: 19 }}>
                    Price Table
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="webadmin-modalmainbody">
                    {Object.keys(pricetableRef?.current)?.length > 0 ? (
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Country</th>
                            <th>Currency</th>
                            <th>InPerson Price</th>
                            <th>InPerson Offer Price</th>
                            <th>Live Online</th>
                            <th>Live Online Offer</th>
                            <th>Self Study</th>
                            <th>Self Offer Price</th>
                          </tr>
                        </thead>
                        <tbody>
                        {Object.keys(pricetableRef?.current)?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{pricetableRef?.current[item]?.country}</td>
                              <td>{pricetableRef?.current[item]?.currency}</td>
                              <td>
                                <input 
                                value={pricetableRef?.current[item]?.personprice} 
                                onChange={(t) => {handlepricechange(item,'personprice', t.target.value)}} type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                              <td>
                                <input 
                                value={pricetableRef?.current[item]?.personofferprice} 
                                onChange={(t) => {handlepricechange(item,'personofferprice', t.target.value)}}
                                type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                              <td>
                              <input 
                              value={pricetableRef?.current[item]?.liveonlineprice} 
                              onChange={(t) => {handlepricechange(item,'liveonlineprice', t.target.value)}}
                              type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                              <td>
                              <input 
                              value={pricetableRef?.current[item]?.liveonlineofferprice} 
                              onChange={(t) => {handlepricechange(item,'liveonlineofferprice', t.target.value)}}
                              type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                              <td>
                                <input 
                                value={pricetableRef?.current[item]?.onlineselfprice} 
                                onChange={(t) => {handlepricechange(item,'onlineselfprice', t.target.value)}}
                                type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                              <td>
                              <input 
                              value={pricetableRef?.current[item]?.onlineselfofferprice} 
                              onChange={(t) => {handlepricechange(item,'onlineselfofferprice', t.target.value)}}
                              type="number" placeholder="Enter Price" className="pricetableinput form-control" />
                              </td>
                             
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                    ) : null}
                    <div
                    className="webadmin-modalbtn"
                    onClick={() => {
                      submithandle();
                    }}
                  >
                    <p>Submit</p>
                  </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      );
}

export default CourseList